import { render, staticRenderFns } from "./fullscreenPreview1.vue?vue&type=template&id=794b93d1&scoped=true&"
import script from "./fullscreenPreview1.vue?vue&type=script&lang=js&"
export * from "./fullscreenPreview1.vue?vue&type=script&lang=js&"
import style0 from "./fullscreenPreview1.vue?vue&type=style&index=0&id=794b93d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b93d1",
  null
  
)

export default component.exports